import React, { FC } from 'react';
import styles from './insights_box.module.scss';

type Props = {
  children: React.ReactNode;
  noStroke?: boolean;
};

export const InsightsBox: FC<Props> = ({ children, noStroke }) => (
  <div className={noStroke ? styles.innerNoStroke : styles.inner}>
    {children}
  </div>
);
